import { render, staticRenderFns } from "./FinancesClientsModal.vue?vue&type=template&id=0a532566"
import script from "./FinancesClientsModal.vue?vue&type=script&lang=js"
export * from "./FinancesClientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports